import { FC } from 'react'
import { getTimeLeftAndTranslationKey, useStores } from '@/utils'
import { observer } from 'mobx-react'
import { IUserQuestion, MessageType } from '@/types'
import { Button } from '@/components/atoms/Button'
import styles from './index.module.scss'

type Props = {
  pollInstance: IUserQuestion
}

export const PollBoxBody: FC<Props> = observer(({ pollInstance }) => {
  const { messages, viewer } = useStores()
  const sumOfVotes = pollInstance?.votesCount

  const onClickVote = async (id: string) => {
    const isSuccessful = await pollInstance.voteForChoice(id)
    if (isSuccessful) {
      messages.add({
        type: MessageType.Info,
        body: 'You voted.',
        isTranslated: true,
        ttl: 5000,
      })
      pollInstance.fetch()
    }
  }

  const { timeLeft, key } = getTimeLeftAndTranslationKey(pollInstance?.pollDeadline)

  const getVoteRate = (votes: number) => {
    if (Number.isNaN(votes) || votes === 0) {
      return 0
    }
    return Math.floor((votes * 100) / sumOfVotes)
  }

  return (
    <>
      <p className={styles.title}>{pollInstance?.title}</p>
      {pollInstance.isVotedInBy ||
      !pollInstance.isVotable ||
      pollInstance.questioner?.username === viewer.viewer?.username ? (
        <div className={styles.body}>
          {pollInstance?.choices.map((choice) => {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
            if (!pollInstance.isVotable && pollInstance.mostVotedChoices?.some((m) => m.id === choice.id)) {
              return (
                <div key={choice.id} className={styles.votedItem}>
                  <div className={styles.coloredBar} style={{ width: `${getVoteRate(choice.votes)}%` }} />
                  <div className={styles.boldText}>{choice?.name}</div>
                  <div className={styles.boldText}>{`${getVoteRate(choice.votes)}%`}</div>
                </div>
              )
            }
            return (
              <div key={choice.id} className={styles.votedItem}>
                <div className={styles.bar} style={{ width: `${getVoteRate(choice.votes)}%` }} />
                <div className={styles.text}>{choice?.name}</div>
                <div className={styles.text}>{`${getVoteRate(choice.votes)}%`}</div>
              </div>
            )
          })}
        </div>
      ) : (
        <div className={styles.body}>
          {pollInstance?.choices.map((choice) => {
            return (
              <div key={choice.id} className={styles.choiceItem}>
                <Button
                  styleType='blueFrame'
                  componentType='button'
                  buttonType='button'
                  buttonSize='medium'
                  onClick={() => onClickVote(choice.id)}
                >
                  <span className={styles.text}>{choice?.name}</span>
                </Button>
              </div>
            )
          })}
        </div>
      )}
      <div className={styles.results}>
        <p>{`${sumOfVotes} votes・`}</p>
        {pollInstance.isVotable ? <p>{`${timeLeft} ${key}`}</p> : <p>Final results</p>}
      </div>
    </>
  )
})
